import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownTimerProps = {
  tone?: "light" | "dark";
};
export function CountdownTimer({
  tone = "light"
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const labelColor = tone === "dark" ? "text-rose-soft" : "text-plum";
  const sepColor = tone === "dark" ? "text-white/70" : "text-plum";
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-27" data-mp="1ach90e0jk030">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${labelColor}`} data-id="element-28" data-mp="1aetpsnukc4eh">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" data-mp="34qrxumh4yu8s" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-30" data-mp="2zrnnvtme0she">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-31" data-mp="1c05hzu9wmfqy" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-serif text-3xl font-bold ${sepColor}`} data-id="element-32" data-mp="1bzdnkms1mo29">:</span>}
            <div className="flex flex-col items-center" data-id="element-33" data-mp="1h1co7owef6vi">
              <span className="flex h-[72px] w-[76px] items-center justify-center rounded-xl bg-plum-dark font-serif text-4xl font-bold tabular-nums text-white shadow-lg sm:h-20 sm:w-20" data-id="element-34" data-mp="1230pzdtdnq28">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-35" data-mp="1urohvs8mtdor">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}